import script from "./indexAnnualFeeDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./indexAnnualFeeDetail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__